import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ANALYTICS_BACKGROUND_REPORT } from '../../services/smart-site-analytics.service';
import { LoaderKind, LoaderService } from '../../services/common/loader.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(
    private loadingService: LoaderService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(ANALYTICS_BACKGROUND_REPORT)) return next.handle(request);
    const kind = this.loaderKind(request);
    this.loadingService.begin(kind);
    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.end(kind);
      })
    );
  }

  /**
   * Data loads, saves, deletes, and uploads use the full-screen spinner.
   * Menu-rights refresh stays silent.
   */
  private loaderKind(request: HttpRequest<unknown>): LoaderKind {
    const url = request.url.toLowerCase();
    if (url.includes('menuaccess') || url.includes('menulist/')) {
      return 'off';
    }
    return 'block';
  }
}
